import { render, staticRenderFns } from "./LoaderApi.vue?vue&type=template&id=44c36e7d&scoped=true&"
import script from "./LoaderApi.vue?vue&type=script&lang=js&"
export * from "./LoaderApi.vue?vue&type=script&lang=js&"
import style0 from "./LoaderApi.vue?vue&type=style&index=0&id=44c36e7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c36e7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
